import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import { ApiUrlConstant } from "../../../../constants/api-url.constant";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";
@Injectable()
export class MostAffectedWarehousesService {
  apiUrl = environment.gateWayHost;
  constructor(
    public generic: GenericHttpService,
    private urlConstant: ApiUrlConstant
  ) {}

  getMostAffectedWarehouses(param, query): Observable<any> {
    const option = {
      method: "GET",
      url: param.api, //`${this.apiUrl}${param.api}`,
      query: query
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.generic.responseData)
    );
  }
}
